window.initFaqSection = function (sectionId) {
    const section = document.querySelector(
        `#faq-section-${sectionId}`
    );

    if (!section) return;

    const items = section.querySelectorAll('.faq-item');

    function openFaq(item) {
        const button = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');

        item.classList.add('active-faq');
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
    }

    function closeFaq(item) {
        const button = item.querySelector('.faq-question');
        const answer = item.querySelector('.faq-answer');

        item.classList.remove('active-faq');
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
    }

    items.forEach((item) => {
        const button = item.querySelector('.faq-question');

        button.addEventListener('click', () => {
            if (item.classList.contains('active-faq')) {
                closeFaq(item);
            } else {
                openFaq(item);
            }
        });
    });

    // Open first FAQ on load
    if (items.length) {
        openFaq(items[0]);
    }

    window.addEventListener('resize', () => {
        section
            .querySelectorAll('.faq-item.active-faq')
            .forEach((item) => {
                const answer = item.querySelector('.faq-answer');
                answer.style.maxHeight =
                    answer.scrollHeight + 'px';
            });
    });
};